var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooklet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 340 340",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M169.522 300.422c6.132-71.922 9.628-139.643 0-186.438 0 0-75.543-38.014-153.33-2.724a9.811 9.811 0 0 0-5.714 8.949v180.213z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M169.522 300.422c4.806-78.156 9.409-159.969 16.7-193.06 26.728-9.033 81.8-21.395 137.584 3.9a9.812 9.812 0 0 1 5.715 8.95v180.21z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D0FF",
    d: "M186.223 107.363a147.159 147.159 0 0 0-16.7 6.621v186.438h16.7z",
    opacity: 1,
    "data-original": "#B8D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D0FF",
    d: "M160.691 296.612c-22.8-8.928-86.357-28.132-150.213 3.81v29.532c72.871-20.688 129.92-8.667 150.624-2.723a30.7 30.7 0 0 0 16.858.026c20.877-5.935 78.585-18.021 151.562 2.7v-29.535c-63.934-31.981-128.178-12.691-151.154-3.777a24.322 24.322 0 0 1-17.677-.033z",
    opacity: 1,
    "data-original": "#B8D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M158.4 285.119c-15.579-18.268-48.416-47.347-104.038-55.23a11.118 11.118 0 0 1-9.607-10.989V51.727a8.264 8.264 0 0 1 9.206-8.215c86 10.117 115.561 70.472 115.561 70.472V281a6.321 6.321 0 0 1-11.122 4.119z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF476F",
    d: "M80.992 182.737a83.507 83.507 0 0 1 22.8 11.032V166.62a81.236 81.236 0 0 0-22.8-11.162z",
    opacity: 1,
    "data-original": "#EF476F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed7aa",
    d: "M282.584 110.426a13.282 13.282 0 0 0-9.544 3.667 15.106 15.106 0 0 0-5.022 11.2c1.9 7.905 5.836 12.3 11.113 14.373 6.163.116 10.838-2.753 14.306-8.041q.12-.623.214-1.277c2.396-16.67-5.48-19.748-11.067-19.922z",
    opacity: 1,
    "data-original": "#fed7aa"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc93e4",
    d: "M283.185 9.954a6.316 6.316 0 0 1 6.234 5.261c2.493 14.7 8.707 57.486 3.609 93.309a7.193 7.193 0 0 1-7.112 6.2h-6.658a7.166 7.166 0 0 1-7.1-6.115c-2.269-15.351-5.677-55.345 4.978-94.22a6.216 6.216 0 0 1 6.049-4.435z",
    opacity: 1,
    "data-original": "#bc93e4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEAAC",
    d: "M282.851 189.92c-25.179-4.667-33.659-23-36.5-34a18.657 18.657 0 0 0-17.139-14.158q-.222-.009-.444-.015A18.612 18.612 0 0 0 213.743 149a67.475 67.475 0 0 0-14.324 43.921c1.133 35.405 29.937 63.769 65.318 65.492 32.92 1.6 42.817-21.078 41.887-36.8-.4-6.78-1.325-13.5-3.652-17.729-4.128-7.506-11.694-12.403-20.121-13.964z",
    opacity: 1,
    "data-original": "#FFEAAC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.917,
    cy: 213.763,
    r: 12.251,
    fill: "#06D6A0",
    opacity: 1,
    "data-original": "#06D6A0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.408,
    cy: 180.094,
    r: 9.012,
    fill: "#fb923c",
    opacity: 1,
    "data-original": "#fb923c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.031,
    cy: 228.622,
    r: 13.686,
    fill: "#EF476F",
    opacity: 1,
    "data-original": "#EF476F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb923c",
    d: "M293.416 131.621a11.92 11.92 0 0 1-5.4 2.77 1.765 1.765 0 0 1-2.116-1.644 21.659 21.659 0 0 0-2.268-7.724 1.75 1.75 0 0 0-3.025-.187 17.2 17.2 0 0 1-7.1 5.535 1.3 1.3 0 0 1-1.661-.553 17.689 17.689 0 0 0-3.828-4.525 18.03 18.03 0 0 0 .438 3.891 17.881 17.881 0 0 1 .431 4.8l.008.03-.017-.031a13.489 13.489 0 0 1-1.5 5.613c-1.891 3.6.536 8.141 4.47 8.06 6.993-.144 15.242-2.144 19.417-9.79l.009-.006a21.451 21.451 0 0 0 2.142-6.239z",
    opacity: 1,
    "data-original": "#fb923c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.871 163.8c-10.742-7.9-23.394-11.538-23.921-11.709a3.352 3.352 0 0 0-4.458 3.366v27.279a3.5 3.5 0 0 0 2.5 3.356 81.446 81.446 0 0 1 21.738 10.5c3.006 1.559 5.561-.512 5.561-2.828V166.62a3.5 3.5 0 0 0-1.42-2.82zm-5.571 23.6a87.86 87.86 0 0 0-15.8-7.221v-19.828a76.482 76.482 0 0 1 15.8 8.075zM80.219 83.8c1.088.246 3.838.911 4.134.911 3.991.049 4.814-5.889.889-6.886-2.733-.817-6.721-2.014-7.663 1.789a3.5 3.5 0 0 0 2.64 4.186zM104.236 92.46c22.528 9.993 38.595 27.354 38.754 27.528 2.85 2.64 8.423-.564 5.164-4.726-.689-.754-17.169-18.594-41.079-29.2-4.175-1.831-7.025 4.517-2.839 6.398zM80.219 109.656c35.23 7.981 62.544 35.988 62.833 36.252 4.13 3.436 7.735-1.943 5.04-4.857-1.166-1.212-29.009-29.768-66.326-38.222-4.484-.936-6.034 5.725-1.547 6.827zM80.219 135.511c35.23 7.981 62.561 35.97 62.833 36.252a3.99 3.99 0 0 0 4.948.09 3.421 3.421 0 0 0 .092-4.948c-1.166-1.211-29.009-29.767-66.326-38.221a3.5 3.5 0 1 0-1.547 6.827zM122.73 172.519c-4-2.2-7.4 3.87-3.4 6.118 12.46 6.929 23.568 18.813 23.678 18.932.69.743 3.26 1.675 4.946.184a3.47 3.47 0 0 0 .186-4.945c-.484-.519-11.956-12.808-25.41-20.289zM147.952 223.608a3.488 3.488 0 0 0 .186-4.945c-.482-.519-11.954-12.808-25.409-20.289a3.5 3.5 0 0 0-3.4 6.118c12.46 6.928 23.568 18.813 23.678 18.932.693.743 3.308 1.676 4.945.184z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.105 110.862a165.756 165.756 0 0 0-17.425-7.5 3.5 3.5 0 1 0-2.375 6.586 159.144 159.144 0 0 1 14.717 6.216v178.711c-56.72-25.189-111-16.435-153 .142V116.22c11.339-6.23 54.416-17.728 79.265-16.418a3.5 3.5 0 1 0-.03-7.006c-24.729-1.341-69.186 10.1-81.241 16.646-24.384-36.936-60.052-64.063-126.009-70.292a3.485 3.485 0 0 0-3.753 3.492v56c-5.922 1.636-20.582 6.013-32.444 12.261a3.472 3.472 0 0 0-1.832 3.078V329.83a3.585 3.585 0 0 0 4.456 3.491c86.527-24.219 145.254-3.147 158.065-.1 12.952-2.916 72.478-24.2 159.067.1 2.867.533 4.456-.931 4.456-3.469V113.984a3.49 3.49 0 0 0-1.917-3.122zm-317.127 5.264a174.741 174.741 0 0 1 27.276-10.2v122.84a3.5 3.5 0 0 0 3.249 3.491c61.3 6.276 90.942 27.763 116.473 60.7-43.463-15.263-90.383-22.42-147 1.919zm152.044 208.926c-44.022-12.282-88.592-15.48-152.044.306v-7.487c67.98-29.651 141.1-4.207 152.044-.072zm0-14.728c-40.945-14.009-97.511-22.174-152.044-.067V302.6c54.679-26.458 113.444-16.715 152.044.048zm0-22.4c-4.548-6.352-36.4-56.489-117.768-62.391V46.438c59.8 5.692 98.087 35.323 117.768 68.407zm160 37.433c-49.289-15.351-120.8-11.327-153-.288v-7.189c10.3-3.885 84.571-29.854 153-.01zm0-15.1c-54.437-22.179-112.194-13.839-153 .153v-7.749c12.5-5.553 83.087-33.867 153-.061z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.87 14.629c-1.487-10.093-16.517-10.959-19.106-1.162-11.8 46.844-7.207 86.363-3.993 98.944-9.908 10.9-1.813 16.894-5.494 25.556-3.17 5.544 1.106 13.51 7.639 13.187 14.411-.3 23.36-7.509 25.2-20.308 1.077-7.5.3-13.348-2.29-17.453 8.914-34.236.147-82.393-1.956-98.764zm-12.355.688c.718-2.619 5.124-2.355 5.454.483 2.733 16.119 8.554 57.375 3.594 92.23a3.672 3.672 0 0 1-3.647 3.2h-6.658a3.646 3.646 0 0 1-3.634-3.127c-1.202-8.134-6.613-50.813 4.891-92.786zm9.672 114.533c-1.351 9.4-7.374 14.078-18.416 14.306a1.415 1.415 0 0 1-1.22-.735 2.234 2.234 0 0 1-.079-2.2c5.05-8.009-2.743-16.98 4.383-23.969a10.553 10.553 0 0 0 4.4.972c2.311-.1 7.813.343 9.947-.538 1.403 2.666 1.756 6.8.985 12.164zM310.118 221.411c-.509-19.621-8.582-30.852-26.63-34.934-43.512-9.094-23.119-45.264-54.137-48.215-23.582-.685-34.213 35.547-33.431 54.772 1.109 37.943 33.526 68.988 71.992 68.959 24.851.677 43.434-16.493 42.206-40.582zm-15.6 24.114c-6.789 6.86-16.758 10.016-29.61 9.394-33.7-1.64-60.929-28.922-61.991-62.109-.943-14.629 8.042-48.026 26.152-47.554a15.063 15.063 0 0 1 13.893 11.536c2.968 11.49 12.013 31.521 39.251 36.569 7.77 1.44 14.219 5.892 17.694 12.214 4.941 10.58 5.004 30.425-5.389 39.95z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooklet);
export default __webpack_public_path__ + "static/media/booklet.bf3076b41f0e555ea5b4242e41649b9c.svg";
export { ForwardRef as ReactComponent };